// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TfIh","productName":"Table_productName__1Zl7w"};